import { GetUpdateAddressFromAddressSummary } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

export const getUpdateAddressFromAddressSummaryTag = (options: GetUpdateAddressFromAddressSummary) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const updateAddressFromAddressSummaryEvent = [
    {
      eventInfo: {
        eventName: 'address summary',
        eventAction: options.eventAction,
      },
    },
  ];

  const { modal, user } = getPODModalTag(
    'Address the Envelope - Recipient',
    updateAddressFromAddressSummaryEvent,
    options.projectID,
  );

  modal.messages = [
    {
      statusMessages: options.statusMessage,
    },
  ];

  return {
    modal,
    product,
    user,
  };
};
